import { render, staticRenderFns } from "./IconHumanFace.vue?vue&type=template&id=3395045a&"
import script from "./IconHumanFace.vue?vue&type=script&lang=js&"
export * from "./IconHumanFace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports